// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__39OhA","savePackageButton":"ClientWallet_savePackageButton__3N3yp"};